import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useUsuario } from "../../../Hooks/UsuarioHook";
import { IssqnInformado, Order, useIssqn } from "../../../Storage/issqn";
import { FormataMoeda } from "../../../Utils/FormataMoeda";
import { FormataData } from "../../../Utils/FormataData";
import theme from "../../../Styles/theme";
import { Boleto } from "../../Boleto";
import ReactToPrint from "react-to-print";
import { cpfMask } from "../../../Utils/mascaras";
import { adicionaDigitos } from "../../Boleto/Utils/adicionaDigitos";
import { CotaninerArrow, HeaderTableSpam } from "./styles";
import { ChevronDown, ChevronUp } from "react-feather";
import { useNavigate } from "react-router-dom";
import { app_base_url } from "../../../Utils/Urls";
import { useEntidade } from "../../../Hooks/EntidadeHook";
import { useEmpresa } from "../../../Storage/empresa";
import { useSeletor } from "../../../Storage/seletor";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  CircularProgress,
} from "@mui/material";
import { useUsuarioNaoEmiteNota } from "../../../Hooks/UsuarioNaoEmiteNotaHook";
import { useUsuarioPrefeitura } from "../../../Hooks/UsuarioPrefeituraHook";
import { useState } from "react";
import { API } from "../../../Services/Api";

interface Props {
  imprimir?: boolean;
  help?: React.Dispatch<React.SetStateAction<boolean>>;
}

export function ListagemIssqn({ imprimir }: Props) {
  const { usuario } = useUsuario();
  const { usuarioNaoEmiteNota } = useUsuarioNaoEmiteNota();
  const { usuarioPrefeitura } = useUsuarioPrefeitura();

  const {
    loading,
    issqnInformadoFiltrado,
    colunas,
    ordenacao,
    handleOrdenacao,
    setEmpresaFocus,
  } = useIssqn();

  const { entidade } = useEntidade();
  const { resumo, alterados } = useSeletor();
  const { getEmpresaFocus } = useEmpresa();

  const navigate = useNavigate();
  const rows = issqnInformadoFiltrado;

  const componentRef = React.useRef<HTMLDivElement | null>(null);

  const [issqnFocus, setIssqnFocus] = React.useState({} as IssqnInformado);
  const [baseTotal, setBaseTotal] = React.useState(0);
  const [baseITotal, setBaseITotal] = React.useState(0);
  const [issTotal, setIssTotal] = React.useState(0);
  const [issITotal, setIssITotal] = React.useState(0);
  const [openCancelar, setOpenCancelar] = useState(false);
  const [idCancelar, setIdCancelar] = useState<number | null>(null);
  const [calculando, setCalculando] = React.useState(false);

  const [openGuia, setOpenGuia] = useState(false);
  const [loadingGuia, setLoadingGuia] = useState(false);

  React.useEffect(() => {
    setCalculando(true);

    if (rows) {
      let help_t = 0;
      let help_ti = 0;
      let help_i = 0;
      let help_ii = 0;

      for (let index = 0; index < rows.length; index++) {
        const element = rows[index];
        if (
          (alterados &&
            (element.BASE_CALCULADA != element.BASE ||
              element.ISSQN != element.VALOR_CALCULADO)) ||
          !alterados
        ) {
          help_t += element.BASE_CALCULADA;
          help_ti += element.BASE;
          help_i += element.VALOR_CALCULADO;
          help_ii += element.ISSQN;
        }
      }

      setBaseTotal(help_t);
      setBaseITotal(help_ti);
      setIssTotal(help_i);
      setIssITotal(help_ii);
    }

    setCalculando(false);
  }, [rows, alterados]);

  function abrirCancelar(id: number) {
    setIdCancelar(id);
    setOpenCancelar(true);
  }

  async function confirmarCancelamento() {
    if (!idCancelar) return;

    const cpf =
      usuario?.CPF ||
      usuarioNaoEmiteNota?.CPF ||usuarioNaoEmiteNota?.CGCMF ||
      usuarioPrefeitura?.usuario?.cpf;

    if (!cpf) {
      alert("Usuário ainda não carregado");
      return;
    }

    try {
      await API.delete(
        `/issqn-informado/${
          usuarioPrefeitura.usuario ? "prefeitura" : "fornecedor"
        }/cancelar/${idCancelar}?usuario_cancelou=${cpf}`
      );

      setOpenCancelar(false);
      window.location.reload();
    } catch (error) {
      console.error(error);
      alert("Erro ao cancelar registro");
    }
  }

  async function abrirGuia(row: IssqnInformado) {
    try {
      setLoadingGuia(true);
      setIssqnFocus(row);
      setOpenGuia(true);

      const empresa = await getEmpresaFocus(Number(row.FORNECEDOR));
      setEmpresaFocus(empresa);
    } catch (error) {
      console.error(error);
      alert("Erro ao carregar dados da guia.");
      setOpenGuia(false);
    } finally {
      setLoadingGuia(false);
    }
  }

  function hide(
    tipo:
      | "PERIODO"
      | "STATUS"
      | "BASE"
      | "ISSQN"
      | "INFORMANTE"
      | "DATA_INFORMACAO"
      | "MOTIVO"
      | "VENCIMENTO"
      | "CODIGO"
      | "VALOR_CALCULADO"
      | "BASE_CALCULADA"
  ) {
    if (colunas[tipo]) return false;
    return true;
  }

  function defineStatus(item: IssqnInformado) {
    if (item.COMPUTADA == "N") return "NÃO COMPUTADO";
    if (item.COMPUTADA == "P") return "PAGO";
    if (item.COMPUTADA == "S") return "COMPUTADO";
    if (item.COMPUTADA == "C") return "CANCELADO";
    return "";
  }

  function renderBackGround(item: IssqnInformado) {
    if (item.COMPUTADA == "N") return "rgba(245, 174, 39, 0.24)";
    if (item.COMPUTADA == "C") return "rgba(245, 62, 39, 0.5)";
    if (item.COMPUTADA == "S") return "rgba(39, 153, 245, 0.24)";
    if (item.COMPUTADA == "P") return "rgba(39, 245, 92, 0.24)";
    return theme.colors.secondary;
  }

  function defineColor(parametro: Order) {
    if (
      ordenacao.ORDER == parametro.ORDER &&
      ordenacao.PARAMETRO == parametro.PARAMETRO
    ) {
      return theme.colors.primary;
    }
    return theme.colors.darkGrey;
  }

  return (
    <>
      {loading ? (
        ""
      ) : (
        <div>
          <br />

          <TableContainer component={Paper} sx={{ width: "100vw", overflowX: "auto" }}>
            <Table sx={{ width: "100%" }} aria-label="simple table" size="small">
              <TableHead>
                <TableRow>
                  {window.location.href.indexOf("geral") == -1 ? (
                    ""
                  ) : (
                    <TableCell
                      style={{ fontSize: "10px" }}
                      align="center"
                      onClick={() => handleOrdenacao("DESCRICAO")}
                    >
                      {imprimir ? (
                        "DESCRIÇÃO"
                      ) : (
                        <HeaderTableSpam>
                          <CotaninerArrow>
                            <ChevronUp
                              size={"18PX"}
                              style={{
                                color: defineColor({
                                  ORDER: -1,
                                  PARAMETRO: "DESCRICAO",
                                }),
                              }}
                            />
                            <ChevronDown
                              size={"18PX"}
                              style={{
                                color: defineColor({
                                  ORDER: 1,
                                  PARAMETRO: "DESCRICAO",
                                }),
                              }}
                            />
                          </CotaninerArrow>
                          DESCRIÇÃO
                        </HeaderTableSpam>
                      )}
                    </TableCell>
                  )}

                  {hide("PERIODO") ? (
                    ""
                  ) : (
                    <TableCell style={{ fontSize: "10px" }} align="center" onClick={() => handleOrdenacao("PERIODO")}>
                      {imprimir ? (
                        "PERÍODO"
                      ) : (
                        <HeaderTableSpam>
                          <CotaninerArrow>
                            <ChevronUp
                              size={"18PX"}
                              style={{
                                color: defineColor({
                                  ORDER: -1,
                                  PARAMETRO: "PERIODO",
                                }),
                              }}
                            />
                            <ChevronDown
                              size={"18PX"}
                              style={{
                                color: defineColor({
                                  ORDER: 1,
                                  PARAMETRO: "PERIODO",
                                }),
                              }}
                            />
                          </CotaninerArrow>
                          PERÍODO
                        </HeaderTableSpam>
                      )}
                    </TableCell>
                  )}

                  {hide("STATUS") ? (
                    ""
                  ) : (
                    <TableCell style={{ fontSize: "10px" }} align="center" onClick={() => handleOrdenacao("STATUS")}>
                      {imprimir ? (
                        "STATUS"
                      ) : (
                        <HeaderTableSpam>
                          <CotaninerArrow>
                            <ChevronUp
                              size={"18PX"}
                              style={{
                                color: defineColor({
                                  ORDER: -1,
                                  PARAMETRO: "STATUS",
                                }),
                              }}
                            />
                            <ChevronDown
                              size={"18PX"}
                              style={{
                                color: defineColor({
                                  ORDER: 1,
                                  PARAMETRO: "STATUS",
                                }),
                              }}
                            />
                          </CotaninerArrow>
                          STATUS
                        </HeaderTableSpam>
                      )}
                    </TableCell>
                  )}

                  {hide("BASE") ? (
                    ""
                  ) : (
                    <TableCell style={{ fontSize: "10px" }} align="center" onClick={() => handleOrdenacao("BASE")}>
                      {imprimir ? (
                        "BASE INFORMADA"
                      ) : (
                        <HeaderTableSpam>
                          <CotaninerArrow>
                            <ChevronUp
                              size={"18PX"}
                              style={{
                                color: defineColor({
                                  ORDER: -1,
                                  PARAMETRO: "BASE",
                                }),
                              }}
                            />
                            <ChevronDown
                              size={"18PX"}
                              style={{
                                color: defineColor({
                                  ORDER: 1,
                                  PARAMETRO: "BASE",
                                }),
                              }}
                            />
                          </CotaninerArrow>
                          BASE INFORMADA
                        </HeaderTableSpam>
                      )}
                    </TableCell>
                  )}

                  {hide("BASE_CALCULADA") ? (
                    ""
                  ) : (
                    <TableCell style={{ fontSize: "10px" }} align="center" onClick={() => handleOrdenacao("BASE_CALCULADA")}>
                      {imprimir ? (
                        "BASE CALCULADA"
                      ) : (
                        <HeaderTableSpam>
                          <CotaninerArrow>
                            <ChevronUp
                              size={"18PX"}
                              style={{
                                color: defineColor({
                                  ORDER: -1,
                                  PARAMETRO: "BASE_CALCULADA",
                                }),
                              }}
                            />
                            <ChevronDown
                              size={"18PX"}
                              style={{
                                color: defineColor({
                                  ORDER: 1,
                                  PARAMETRO: "BASE_CALCULADA",
                                }),
                              }}
                            />
                          </CotaninerArrow>
                          BASE CALCULADA
                        </HeaderTableSpam>
                      )}
                    </TableCell>
                  )}

                  {hide("ISSQN") ? (
                    ""
                  ) : (
                    <TableCell style={{ fontSize: "10px" }} align="center" onClick={() => handleOrdenacao("ISSQN")}>
                      {imprimir ? (
                        "ISS INFORMADO"
                      ) : (
                        <HeaderTableSpam>
                          <CotaninerArrow>
                            <ChevronUp
                              size={"18PX"}
                              style={{
                                color: defineColor({
                                  ORDER: -1,
                                  PARAMETRO: "ISSQN",
                                }),
                              }}
                            />
                            <ChevronDown
                              size={"18PX"}
                              style={{
                                color: defineColor({
                                  ORDER: 1,
                                  PARAMETRO: "ISSQN",
                                }),
                              }}
                            />
                          </CotaninerArrow>
                          ISS INFORMADO
                        </HeaderTableSpam>
                      )}
                    </TableCell>
                  )}

                  {hide("VALOR_CALCULADO") ? (
                    ""
                  ) : (
                    <TableCell style={{ fontSize: "10px" }} align="center" onClick={() => handleOrdenacao("VALOR_CALCULADO")}>
                      {imprimir ? (
                        "ISS CALCULADO"
                      ) : (
                        <HeaderTableSpam>
                          <CotaninerArrow>
                            <ChevronUp
                              size={"18PX"}
                              style={{
                                color: defineColor({
                                  ORDER: -1,
                                  PARAMETRO: "VALOR_CALCULADO",
                                }),
                              }}
                            />
                            <ChevronDown
                              size={"18PX"}
                              style={{
                                color: defineColor({
                                  ORDER: 1,
                                  PARAMETRO: "VALOR_CALCULADO",
                                }),
                              }}
                            />
                          </CotaninerArrow>
                          ISS CALCULADO
                        </HeaderTableSpam>
                      )}
                    </TableCell>
                  )}

                  {hide("INFORMANTE") ? (
                    ""
                  ) : (
                    <TableCell style={{ fontSize: "10px" }} align="center" onClick={() => handleOrdenacao("INFORMANTE")}>
                      {imprimir ? (
                        "INFORMANTE"
                      ) : (
                        <HeaderTableSpam>
                          <CotaninerArrow>
                            <ChevronUp
                              size={"18PX"}
                              style={{
                                color: defineColor({
                                  ORDER: -1,
                                  PARAMETRO: "INFORMANTE",
                                }),
                              }}
                            />
                            <ChevronDown
                              size={"18PX"}
                              style={{
                                color: defineColor({
                                  ORDER: 1,
                                  PARAMETRO: "INFORMANTE",
                                }),
                              }}
                            />
                          </CotaninerArrow>
                          INFORMANTE
                        </HeaderTableSpam>
                      )}
                    </TableCell>
                  )}

                  {hide("DATA_INFORMACAO") ? (
                    ""
                  ) : (
                    <TableCell style={{ fontSize: "10px" }} align="center" onClick={() => handleOrdenacao("DATA_INFORMACAO")}>
                      {imprimir ? (
                        "DATA INFORMAÇÃO"
                      ) : (
                        <HeaderTableSpam>
                          <CotaninerArrow>
                            <ChevronUp
                              size={"18PX"}
                              style={{
                                color: defineColor({
                                  ORDER: -1,
                                  PARAMETRO: "DATA_INFORMACAO",
                                }),
                              }}
                            />
                            <ChevronDown
                              size={"18PX"}
                              style={{
                                color: defineColor({
                                  ORDER: 1,
                                  PARAMETRO: "DATA_INFORMACAO",
                                }),
                              }}
                            />
                          </CotaninerArrow>
                          DATA INFORMAÇÃO
                        </HeaderTableSpam>
                      )}
                    </TableCell>
                  )}

                  {hide("VENCIMENTO") ? (
                    ""
                  ) : (
                    <TableCell style={{ fontSize: "10px" }} align="center" onClick={() => handleOrdenacao("VENCIMENTO")}>
                      {imprimir ? (
                        "DATA VENCIMENTO"
                      ) : (
                        <HeaderTableSpam>
                          <CotaninerArrow>
                            <ChevronUp
                              size={"18PX"}
                              style={{
                                color: defineColor({
                                  ORDER: -1,
                                  PARAMETRO: "VENCIMENTO",
                                }),
                              }}
                            />
                            <ChevronDown
                              size={"18PX"}
                              style={{
                                color: defineColor({
                                  ORDER: 1,
                                  PARAMETRO: "VENCIMENTO",
                                }),
                              }}
                            />
                          </CotaninerArrow>
                          DATA DE VENCIMENTO
                        </HeaderTableSpam>
                      )}
                    </TableCell>
                  )}

                  {hide("CODIGO") ? (
                    ""
                  ) : (
                    <TableCell style={{ fontSize: "10px" }} align="center" onClick={() => handleOrdenacao("CODIGO")}>
                      {imprimir ? (
                        "CÓDIGO DE BARRAS"
                      ) : (
                        <HeaderTableSpam>
                          <CotaninerArrow>
                            <ChevronUp
                              size={"18PX"}
                              style={{
                                color: defineColor({
                                  ORDER: -1,
                                  PARAMETRO: "CODIGO",
                                }),
                              }}
                            />
                            <ChevronDown
                              size={"18PX"}
                              style={{
                                color: defineColor({
                                  ORDER: 1,
                                  PARAMETRO: "CODIGO",
                                }),
                              }}
                            />
                          </CotaninerArrow>
                          CÓDIGO DE BARRAS
                        </HeaderTableSpam>
                      )}
                    </TableCell>
                  )}

                  {hide("MOTIVO") ? (
                    ""
                  ) : (
                    <TableCell style={{ fontSize: "10px" }} align="center" onClick={() => handleOrdenacao("MOTIVO")}>
                      {imprimir ? (
                        "MOTIVO"
                      ) : (
                        <HeaderTableSpam>
                          <CotaninerArrow>
                            <ChevronUp
                              size={"18PX"}
                              style={{
                                color: defineColor({
                                  ORDER: -1,
                                  PARAMETRO: "MOTIVO",
                                }),
                              }}
                            />
                            <ChevronDown
                              size={"18PX"}
                              style={{
                                color: defineColor({
                                  ORDER: 1,
                                  PARAMETRO: "MOTIVO",
                                }),
                              }}
                            />
                          </CotaninerArrow>
                          MOTIVO
                        </HeaderTableSpam>
                      )}
                    </TableCell>
                  )}

                  <TableCell align="center" style={{ fontSize: "10px" }}>
                    AÇÕES
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {!resumo
                  ? rows.map((row) =>
                      (alterados &&
                        row.VALOR_CALCULADO != row.ISSQN &&
                        row.BASE_CALCULADA != row.BASE) ||
                      !alterados ? (
                        <TableRow
                          key={row.ID}
                          sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                          style={{ background: renderBackGround(row) }}
                        >
                          {window.location.href.indexOf("geral") == -1 ? (
                            ""
                          ) : (
                            <TableCell
                              align="center"
                              component="th"
                              scope="row"
                              style={{
                                cursor: "pointer",
                                color: theme.colors.primary,
                                fontSize: imprimir ? "12px" : "14px",
                              }}
                              onClick={() => {
                                navigate(`${app_base_url}/${entidade.banco}/firma/${row.FORNECEDOR}`);
                              }}
                            >
                              {row.DESCRICAO}
                            </TableCell>
                          )}

                          {hide("PERIODO") ? "" : <TableCell align="center" style={{ fontSize: "14px" }}>{row.PERIODO}</TableCell>}
                          {hide("STATUS") ? "" : <TableCell align="center" style={{ fontSize: "12px" }}>{defineStatus(row)}</TableCell>}
                          {hide("BASE") ? "" : <TableCell align="center" style={{ fontSize: "14px" }}>{FormataMoeda(row.BASE)}</TableCell>}
                          {hide("BASE_CALCULADA") ? "" : <TableCell align="center" style={{ fontSize: "14px" }}>{FormataMoeda(row.BASE_CALCULADA)}</TableCell>}
                          {hide("ISSQN") ? "" : <TableCell align="center" style={{ fontSize: "14px" }}>{FormataMoeda(row.ISSQN)}</TableCell>}
                          {hide("VALOR_CALCULADO") ? "" : <TableCell align="center" style={{ fontSize: "14px" }}>{FormataMoeda(row.VALOR_CALCULADO)}</TableCell>}
                          {hide("INFORMANTE") ? "" : <TableCell align="center" style={{ fontSize: "14px" }}>{cpfMask(row.CPFINFORMANTE)}</TableCell>}
                          {hide("DATA_INFORMACAO") ? "" : <TableCell align="center" style={{ fontSize: "14px" }}>{FormataData(row.DATA_INFORMACAO)}</TableCell>}
                          {hide("VENCIMENTO") ? "" : <TableCell align="center" style={{ fontSize: "14px" }}>{FormataData(row.VENCIMENTO)}</TableCell>}
                          {hide("CODIGO") ? "" : <TableCell align="center" style={{ fontSize: "14px" }}>{adicionaDigitos(row.CODBARRA)}</TableCell>}
                          {hide("MOTIVO") ? "" : <TableCell align="center" style={{ fontSize: "14px" }}>{row.MOTIVO}</TableCell>}

                          <TableCell align="center">
                            <Button
                              variant="contained"
                              color="primary"
                              sx={{
                                fontWeight: "bold",
                                padding: "8px 16px",
                                textTransform: "uppercase",
                                backgroundColor: theme.colors.primary,
                                "&:hover": {
                                  boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.2)",
                                },
                              }}
                              onClick={() => abrirGuia(row)}
                            >
                              Visualizar Guia
                            </Button>

                            {!row.REGISTRO && (
                              <Button
                                variant="contained"
                                color="error"
                                sx={{
                                  fontWeight: "bold",
                                  padding: "8px 16px",
                                  textTransform: "uppercase",
                                  marginLeft: "4px",
                                  "&:hover": {
                                    boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.2)",
                                  },
                                }}
                                onClick={() => abrirCancelar(row.ID)}
                              >
                                Cancelar
                              </Button>
                            )}
                          </TableCell>
                        </TableRow>
                      ) : (
                        ""
                      )
                    )
                  : ""}

                {calculando ? (
                  "Calculando..."
                ) : (
                  <TableRow
                    key={0}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    style={{ background: theme.colors.secondary }}
                  >
                    {window.location.href.indexOf("geral") == -1 ? "" : <TableCell />}
                    {hide("PERIODO") ? "" : <TableCell align="center">TOTAL</TableCell>}
                    {hide("STATUS") ? "" : <TableCell />}
                    {hide("BASE") ? "" : <TableCell align="center">{FormataMoeda(baseITotal)}</TableCell>}
                    {hide("BASE_CALCULADA") ? "" : <TableCell align="center">{FormataMoeda(baseTotal)}</TableCell>}
                    {hide("ISSQN") ? "" : <TableCell align="center">{FormataMoeda(issITotal)}</TableCell>}
                    {hide("VALOR_CALCULADO") ? "" : <TableCell align="center">{FormataMoeda(issTotal)}</TableCell>}
                    {hide("INFORMANTE") ? "" : <TableCell />}
                    {hide("DATA_INFORMACAO") ? "" : <TableCell />}
                    {hide("VENCIMENTO") ? "" : <TableCell />}
                    {hide("CODIGO") ? "" : <TableCell />}
                    {hide("MOTIVO") ? "" : <TableCell />}
                    <TableCell />
                  </TableRow>
                )}
              </TableBody>
            </Table>

            <Dialog open={openCancelar} onClose={() => setOpenCancelar(false)}>
              <DialogTitle>Confirmar Cancelamento</DialogTitle>
              <DialogContent>
                <Typography>
                  Deseja realmente cancelar esta guia de ISSQN - {idCancelar}?
                </Typography>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setOpenCancelar(false)}>Voltar</Button>
                <Button variant="contained" color="error" onClick={confirmarCancelamento}>
                  Confirmar Cancelamento
                </Button>
              </DialogActions>
            </Dialog>

            <Dialog
              open={openGuia}
              onClose={() => setOpenGuia(false)}
              maxWidth="lg"
              fullWidth
            >
              <DialogTitle>Visualizar Guia ISSQN</DialogTitle>

              <DialogContent dividers sx={{ background: "#f5f5f5" }}>
                {loadingGuia ? (
                  <div
                    style={{
                      minHeight: 300,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                      gap: 12,
                    }}
                  >
                    <CircularProgress />
                    <Typography>Carregando guia...</Typography>
                  </div>
                ) : (
                  <div ref={componentRef}>
                    <div >
                    <Boleto issqn={issqnFocus} modo="print"/>
                    </div>
                  </div>
                )}
              </DialogContent>

              <DialogActions>
                <Button onClick={() => setOpenGuia(false)}>Fechar</Button>

                {!loadingGuia && (
                  <ReactToPrint
                    content={() => componentRef.current}
                    trigger={() => (
                      <Button variant="contained" color="primary">
                        Imprimir
                      </Button>
                    )}
                    onAfterPrint={() => {}}
                  />
                )}
              </DialogActions>
            </Dialog>
          </TableContainer>
        </div>
      )}
    </>
  );
}